// extracted by mini-css-extract-plugin
export var casualties = "casualties-module--casualties--eb-Qv";
export var casualtyCount = "casualties-module--casualtyCount--ev7TO";
export var fatalityCount = "casualties-module--fatalityCount--eo2pP casualties-module--casualtyCount--ev7TO casualties-module--casualtyCount--ev7TO casualties-module--casualtyCount--ev7TO";
export var casualtiesHidden = "casualties-module--casualtiesHidden--++MGx casualties-module--casualties--eb-Qv";
export var notice = "casualties-module--notice--4ThAE";
export var slideUp = "casualties-module--slideUp--vJtTI";
export var slideUpLarge = "casualties-module--slideUpLarge--dqU5f";
export var mobileReveal = "casualties-module--mobileReveal--gfwJR";